import api, { fetchCsrfCookie, unwrap } from './client'
import type { LoginPayload, User } from '@/types/models'

export const authApi = {
  async login(payload: LoginPayload): Promise<User> {
    await fetchCsrfCookie()
    return unwrap(api.post<{ data: User }>('/auth/login', payload))
  },

  user(): Promise<User> {
    return unwrap(api.get<{ data: User }>('/auth/user'))
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout')
  },
}
